import SocialMediaIcons from "../components/SocialMediaIcons";

const Footer = () => {
  return (
    <footer id="footer" className="h-64 bg-black pt-10">
      <div className="w-10/12 mx-auto">
        <SocialMediaIcons />
        <div className="md:flex justify-center md:justify-between text-center ">
          <p className="font-playfair font-semibold text-2xl text-white">
            FATERU OLUWATOBI
          </p>
          <p className="font-playfair text-md text-white">
            ©2022 Beautiful<span className="text-yellow">Mind</span>. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
